import { ConvertDateTimeToText, ConvertDateToText } from 'components/MyControl';
import Css from 'components/pages/application/login/Login.module.css';
import { useEffect, useState } from 'react';
import { Col, Form, Row, Button } from 'react-bootstrap';

export default function ProfileUser({ data = undefined, callSubmitParentData = undefined, parentAlert = '',openEmail=false }) {
    //console.log(data);
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);

    const [mode, setMode] = useState('view');

    const [simulate, setSimulate] = useState(data);

    const handleSetSimulate = (event) => {
        const { name, value } = event.target;

        setSimulate(prevData => {
            return { ...prevData, [name]: value }
        })
    }

    const handleCancel = (event) => {
        setSimulate(data)
        setMode('view')
    }

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }
        callSubmitParentData(simulate);
        setLoading(false);

        if (parentAlert === '') {
            setMode('view')
        } else {
            setMode('edit')
        }
    }

    useEffect(() => {
        setSimulate(data);
    }, [data])

    return (
        data !== undefined &&
        <div className='mt-3 mb-3'>
            <div >
                <Form noValidate validated={validated} onSubmit={event => handleSubmit(event)}>
                    <div className={`border rounded p-4 bg-white shadow w-100`}>
                        <Row>
                            <Col >
                                <div >

                                    <h6 className='mb-4'>
                                        <Row>
                                            <Col><h5 className='text-start text-blue-01'>ข้อมูลผู้ใช้งาน</h5> </Col>
                                            <Col className='text-end'>
                                                {
                                                    mode === 'view' &&
                                                    <Button variant="outline-secondary" type="button" className=''
                                                        onClick={event => setMode('edit')}>
                                                        แก้ไข
                                                        <i className="ms-2 fa-solid fa-pencil"></i>
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>
                                    </h6>
                                    <div>
                                        <Form.Group className='mb-2'>
                                            <Form.Label className='label-title'>ชื่อ</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'first_name'}
                                                value={simulate?.first_name}
                                                placeholder={'ชื่อ'}
                                                required={true}
                                                onChange={handleSetSimulate} />
                                        </Form.Group>
                                        <Form.Group className='mb-2'>
                                            <Form.Label className='label-title'>นามสกุล</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'last_name'}
                                                value={simulate?.last_name}
                                                placeholder={'นามสกุล'}
                                                required={true}
                                                onChange={handleSetSimulate} />
                                        </Form.Group>
                                        <Form.Group className='mb-2'>
                                            <Form.Label className='label-title'>หมายเลขโทรศัพท์</Form.Label>
                                            <Form.Control type={'tel'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'tel'}
                                                value={simulate?.tel}
                                                placeholder={'00-000-0000'}
                                                required={true}
                                                onChange={handleSetSimulate} />
                                        </Form.Group>
                                        <Form.Group className='mb-5'>
                                            <Form.Label className='label-title'>อีเมล</Form.Label>
                                            <Form.Control type={'text'} 
                                                plaintext={(mode === 'view') ? true : (openEmail === false)? true : false}
                                                readOnly={(mode === 'view') ? true : (openEmail === false)? true : false}
                                                placeholder={'อีเมล'}
                                                name={'email'}
                                                className=''
                                                value={simulate?.email}
                                                onChange={handleSetSimulate} />
                                        </Form.Group>

                                        {
                                            (alert + parentAlert) != '' &&
                                            <div className="alert alert-danger" role="alert">
                                                {alert + parentAlert}
                                            </div>
                                        }

                                        {
                                            mode === 'edit' &&
                                            <Row>
                                                <Col>
                                                    <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                        onClick={event => handleCancel(event)}  >ยกเลิก</Button>
                                                    <Button variant="primary" type="submit" className='ps-5 pe-5'
                                                        disabled={loading}
                                                    >บันทึก
                                                        {
                                                            loading === true &&
                                                            <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        }
                                                    </Button>
                                                </Col>
                                            </Row>
                                        }

                                    </div>
                                </div>

                            </Col>
                            <Col className='ps-4 border-start'>
                                <div className={`${Css.Login_inner_layout2} w-100`}>
                                    <h6 className='mb-4'>ข้อมูลล็อคอิน</h6>
                                    <div>
                                        <Form.Group className='mb-2' >
                                            <Form.Label className='label-title'>ล็อคอิน</Form.Label>
                                            <Form.Control type={'text'} className='pt-0' plaintext readOnly
                                                placeholder={'ล็อคอิน'}
                                                value={simulate?.login_name} />
                                        </Form.Group>
                                        <Form.Group className='mb-2' >
                                            <Form.Label className='label-title'>วันที่สมัคร</Form.Label>
                                            <Col>
                                            <Form.Label >{ConvertDateToText(simulate?.create_date)}</Form.Label>
                                            </Col>
                                        </Form.Group>
                                    </div>
                                </div>

                            </Col>
                        </Row>

                    </div>
                </Form>
            </div>
        </div>
    )
}